<template>
  <!-- 能源类型 -->
  <span class="webMenuConfig">
    <div class="con">
      <!-- <div style="margin-bottom:12px;display:flex;justify-content: space-between;">
        <div class="left1" style="display:flex;align-items: center;width:60%">
          <el-input placeholder="请输入菜单名称" v-model="searchName" style="width:35%"></el-input>
          <el-button type="primary" icon="el-icon-search" style="margin:0 20px" @click="search_fn" plain>搜索</el-button>
          <el-button type="primary" @click="addMenu" style="margin-right:40px">新增顶级菜单<i
              class="el-icon-document-add"></i></el-button>
        </div>
        <div class="telephone">
          <i class="el-alert__icon el-icon-info"></i>
          <span>需要配置请致电 12597563241</span>
        </div>
      </div> -->
       <div class="Files-top">
						<div class="ic-left">
						<span>菜单配置</span>
						</div>
						<div class="btns">
               <el-button type="primary" @click="addMenu">新增顶级菜单</el-button>
               <el-button type="primary" @click="drawer_fn" style="margin-right:0px" class="last-el-button">排序</el-button>
						</div>
				</div>
         <div class="search-input-btn" style="width:100%">
						<div class="input-small">
						<span>菜单名称：</span>
						     <el-input placeholder="请输入菜单名称" v-model="searchName"></el-input>
						</div>
						<el-button type="primary" plain @click="search_fn" class="search-btn">查询</el-button>
					</div>
      <el-table  ref="mytable" id="demo" :max-height="heights" 
         :data="tableData" border style="width: 100%" row-key="id"
        :tree-props="{children: 'next', hasChildren: 'hasChildren'}">
        <template slot="empty">
          <span class="noData">
            <img src="@/assets/noData.png" alt="暂无数据">
            <span class="text">暂无数据</span>
          </span>
        </template>
        <el-table-column type="index" label="序号" width="90" align="center">
        </el-table-column>
        <el-table-column label="名称"  width="310" align="left">
          <template slot-scope="{row}">
            <!-- <el-link type="primary" :class="{'actived':mainId===row.id}" @click="tempclick(row)">{{ row.rightname }}
            </el-link> -->
            <div class="name-menu">
                <span  @click="tempclick(row)">{{ row.rightname }}</span>
                <div class="public-flex">
                   <el-tooltip class="item" effect="dark" content="上升" placement="left" style="margin-right:12px">
                     <img src="@/assets/unifyImg/rise.png" alt="" @click="webMenuRise_fn(row,'UP')">
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="下降" placement="right">
                     <img src="@/assets/unifyImg/decline.png" alt="" @click="webMenuRise_fn(row,'DOWN')">
                    </el-tooltip>
                </div>
            </div>
            

          </template>
        </el-table-column>
        <el-table-column label="图形文件" align="center" width="300">
          <template slot-scope="{row}">
                <div class="img-div">
                     <div class="content-img">
                         <img v-if="row.iconFile" :src="'./static/image/科技蓝/menu/'+row.iconFile + '.png'" class="avatar">
                     </div>
                </div>
          </template>
        </el-table-column>
        <el-table-column label="路由"  width="300">
          <template slot-scope="{row}">
            {{ row.webpage || '模块' }}
          </template>
        </el-table-column>
        <el-table-column label="描述"  width="300">
          <template slot-scope="{row}">
            {{ row.memo }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" min-width="200">
          <template #default="{row}">
            <div class="btnssss" style="display: flex;justify-content: center; align-items: center;">
              <div @click="addMenuChild(row)" class="mr-20">
                <el-tooltip class="item" effect="dark" content="添加子区域" placement="top">
                  <elIconBtn btnType='add'></elIconBtn>
                </el-tooltip>
              </div>
              <div @click="editMenu(row)" class="mr-20">
                <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                  <elIconBtn btnType='edit'></elIconBtn>
                </el-tooltip>
              </div>
              <div @click="deleteMenu(row)">
                <el-tooltip class="item" effect="dark" content="删除" placement="top">
                  <elIconBtn btnType='del'></elIconBtn>
                </el-tooltip>
              </div>

            </div>
          </template>
        </el-table-column>
      </el-table>


      <el-drawer title="" :visible.sync="drawer" :with-header="false"  :size="drawerSize">
                   <div class="drawer-con">
                      <div class="Files-top">
                        <div class="ic-left">
                        <span>菜单移动</span>
                        </div>
                        <div class="btns">
                        </div>
                      </div>
                      <div class="dracaozuo" style="display:flex">
                          <div class="dratree" :style="{'width':'320px','height':`${heights+200}px`}">
                                <div class="search">
                                  <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
                                </div>
                                <el-scrollbar style="height:calc(100% - 40px);width: 100%;">
                                  <el-tree :data="tableData" :props="defaultProps" 
                                      :filter-node-method="filterNode"  ref="tree"  @node-click="leftNodeClick">
                                      <span class="custom-tree-node" slot-scope="{node}">
                                          <img src="../../../public/static/image/elTree/2.0.png"  v-show="node.data.next.length != 0"/> 
                                           <span style="padding-left: 5px;">{{node.data.rightname}}</span>
                                      </span>
                                    </el-tree>
                                  </el-scrollbar>
                          </div>
                           <div class="dra-btns">
                               <div class="left-add" @click="determine_fn">移动<img src="@/assets/right.png" alt=""></div>
                           </div>
                          <div class="dratree2" :style="{'width':'320px','height':`${heights+200}px`}">
                               <div class="search">
                                  <el-input placeholder="输入关键字进行过滤" v-model="filterTexts"></el-input>
                                </div>
                                <el-scrollbar style="height:calc(100% - 40px);width: 100%;">
                                  <el-tree :data="tableDataRight" :props="defaultProps" 
                                      :default-expanded-keys="defaultExpanded" 
                                      :current-node-key='defaultDevice'
                                       node-key="rightid"
                                      :filter-node-method="filterNodes"  ref="trees" @node-click="rightNodeClick">
                                      <div class="custom-tree-node" slot-scope="{node}">
                                          <img src="../../../public/static/image/elTree/2.0.png"  v-show="node.data.next.length != 0"/> 
                                          <span style="padding-left: 5px;">{{node.data.rightname}}</span>

                                           <div class="public-flex">
                                              <el-tooltip class="item" effect="dark" content="上升" placement="left" style="margin-right:5px;margin-left:10px;">
                                                <img src="@/assets/unifyImg/rise.png" alt="" @click="webMenuRise_fn(node.data,'UP')">
                                                </el-tooltip>
                                                <el-tooltip class="item" effect="dark" content="下降" placement="right">
                                                <img src="@/assets/unifyImg/decline.png" alt="" @click="webMenuRise_fn(node.data,'DOWN')">
                                                </el-tooltip>
                                            </div>
                                             
                                      </div>
                                    </el-tree>
                                  </el-scrollbar>
                          </div>
                         </div>
                   </div>

                </el-drawer>



      <!-- 新增修改 -->
      <el-dialog v-dialogDrag :title="textMap[dialogStatus]" :close-on-click-modal='false' :visible.sync="dialogVisible"
        width="400" center>
        <el-form :model="temp" :rules="rules" ref="temp" label-width="120px" class="demo-temp">
          <!-- <span style="font-size:18px">已选中菜单（{{deviceName}}）</span> -->
          <el-form-item label="菜单名称:" prop="rightname">
            <el-input v-model="temp.rightname"></el-input>
          </el-form-item>
          <el-form-item label="菜单路径:" prop="webpage">
            <el-input v-model="temp.webpage"></el-input>
          </el-form-item>

          <el-form-item label="图形文件:" prop="iconFile">
            <el-upload class="avatar-uploader" action="http://localhost:8080/" :show-file-list="false"
              :before-upload="beforeAvatarUpload">
              <img v-if="imageUrl" :src="imageUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="是否有子菜单:" prop="hasSonMenu">
            <el-radio v-model="radioValue" label="0">无</el-radio>
            <el-radio v-model="radioValue" label="1">有</el-radio>
          </el-form-item>
          <el-form-item label="描述:" prop="memo">
            <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入内容"
              v-model="temp.memo"></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogStatus==='edit'?edit_fn('temp'):add_fn('temp')">确 定
            </el-button>
          </span>
        </template>
      </el-dialog>

    </div>
  </span>
</template>
<script>

  //  import {} from "../../api/energySubType";
  import menuApi from '@/components/api/menuApi.js'
  import nomalInputDialog from '@/components/module/dialog/nomalInputDialog.vue'
  import userManagerStore from '@/page/userManager/userManagerStore.js'
  import elIconBtn from '@/components/module/iconBtns.vue'
  import {webMenuRise,webMenuMove} from "../../api/abbNewApi";
  export default {
    components: {
      nomalInputDialog,
      elIconBtn,

    },
    data () {
      return {
        filterText: '',
        filterTexts: '',
        drawerSize:"800px",
        drawer: false,
          heights: document.getElementById('app').clientHeight-250,//屏幕高度 - 导航栏高度
        searchName: "",
        imageUrl: '',
        imgIconFile: "",
        radioValue: "0",
        tableData: [],
        tableDataCopy: [],
        NowUnit: {},
        mainId: "",
        nowMenu: "",
        deviceName: "",
        temp: {},
        dialogVisible: false,
        dialogStatus: 'add',
        textMap: {
          add: "新增web顶级菜单",
          addSon: "新增子级菜单",
          edit: "修改web菜单"
        },
        rules: {
          rightname: [
            {required: true,message: '请输入菜单名称',trigger: 'blur'}
          ],


        },
        defaultProps: {
          children: 'next',
          label: 'rightname'
        },
        rightId:"",
        parentRightId:"",
        defaultExpanded:[0],
				defaultDevice:"",
        tableDataRight:[
          {
            'rightid':"",
            'rightname':"全部菜单",
            'next':[]
          }
        ],
        rightidsss:"",
        rightid:"",
        parentRightId:"",
      };
    },
    computed: {


    },
    watch: {
      dialogVisible (val) {
        if(!val) {
          this.imageUrl=''
          this.imgIconFile=""
        }
      },
      searchName (val) {
        if(val=='') {
          this.tableData=this.tableDataCopy
        }
      },
      filterText (val) {
        this.$refs.tree.filter(val);
      },
      filterTexts (val) {
        this.$refs.trees.filter(val);
      },
      
    },
    mounted () {
      
      this.NowUnit=this.$store.unitStore.getters.getNowUnit
      this.getList();//获取列表数据 
       
    },
    methods: {
      
      // handleAvatarSuccess(res, file) {
      //   this.imageUrl = URL.createObjectURL(file.raw);
      // },
      //菜单上升下降
      webMenuRise_fn(row,type){
        var d = {
           'location': type,
           'rightId':row.rightid
        }
        webMenuRise(d).then(res => {
            if(res.code == 200){
                this.getList()
                this.$message({message: "移动成功",type: 'success'});
            }else {
               res.message ?  this.$message({message: res.message,type: 'warning'}) :   this.$message({message: "移动失败",type: 'warning'});
            }
        })
      },
      drawer_fn(){
        this.drawer = true
        this.defaultExpanded = [this.rightidsss]
        this.defaultDevice = this.rightidsss
        this.$nextTick(()=>{
              //默认选中
              this.$refs['trees'].setCurrentKey(this.defaultDevice);
            })
      },
      //左边预选菜单
      leftNodeClick(row){
        console.log("row",row);
        this.rightid = row.rightid
        this.rightidsss = JSON.parse(JSON.stringify(this.rightid))
      },
      //右边绝对菜单
      rightNodeClick(row){
        this.parentRightId =  row.rightid
        
      },
      //确定移动菜单
      determine_fn(){
        var d  = {
          'rightId':this.rightid,
          'parentRightId':this.parentRightId,
        }
        
        if(this.rightid == ""){
           this.$message({message: "请选择需要移动的模块或者路由",type: 'warning'})
           return
        }
        console.log("参数",d);
        webMenuMove(d).then(res => {
          console.log("结构",res);
          if(res.code == 200){
             this.getList()
             this.rightid = ""
            this.$message({message: "移动成功",type: 'success'});
          }else {
             res.message ? this.$message({message: res.message,type: 'error'}) : this.$message({message: "移动失败",type: 'error'})
          }
        })

      },
      //图片选择
      beforeAvatarUpload (file) {
        const isJPG=file.type==='image/jpeg';
        const isLt2M=file.size/1024/1024<2;
        var fileName=file.name
        this.imgIconFile=fileName.slice(0,fileName.length-4)
        this.imageUrl="./static/image/科技蓝/menu/"+file.name

        return isJPG&&isLt2M;
      },
      //搜索列表
      search_fn () {
        // this.tableData = []
        var data=JSON.parse(JSON.stringify(this.tableDataCopy))
        var arr=[]
        var searchName=this.searchName
        var recursiveFunction=function() {
          const getStr=function(list) {
            list.forEach(function(row) {
              if(row.next.length!=0) {
                if(row.rightname.includes(searchName)) {
                  arr.push(row)
                }
                getStr(row.next)
              } else {

                if(row.rightname.includes(searchName)) {
                  arr.push(row)
                }

              }
            })
          }
          getStr(data)
        }
        recursiveFunction()
        arr.forEach(item => item.next=[])
        this.tableData=arr
      },
       //输入关键字进行过滤
      filterNode (value,data) {
        if(!value) return true;
        return data.rightname.indexOf(value)!==-1;
      },
       //输入关键字进行过滤
      filterNodes (value,data) {
        if(!value) return true;
        return data.rightname.indexOf(value)!==-1;
      },
      //弹出绑定设备
      tempclick (v) {
        this.mainId=v.id;
        this.nowMenu=v
        this.deviceName=v.rightname
        // this.getDevice()
        // if (this.$refs.child) {
        //   this.$refs.child.childMethod(this.mainId);
        // }
      },
      //添加顶级菜单（新）
      addMenu () {
        this.dialogStatus='add';
        this.dialogVisible=true;
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
        this.temp={};
      },
      // 确认添加
      add_fn (formName) {
        this.$refs[formName].validate(valid => {
          if(valid) {

            if(this.dialogStatus=='add') {
              this.$api.menuApi.saveMenuAdd(this.temp.rightname,"menuright",'1',this.temp.webpage,"1","1",this.radioValue,this.imgIconFile,this.temp.memo,respon => {
                // this.$dialogMethod.showMessage("添加成功!")

                this.$message({message: "添加成功",type: 'success'});
                //刷新页面
                this.getList()
                this.dialogVisible=false
              },respon => {
                this.$message({message: respon,type: 'error'});
              })
            } else {
              var parentid=this.nowMenu.id //当前选中web菜单的id
              var serialno=this.nowMenu.serialno+1
              // this.$api.menuApi.saveMenu("", item.rightname,

              this.$api.menuApi.saveMenuSon(this.temp.rightname,
                "menuright",serialno,this.temp.webpage,parentid,"1","1",this.radioValue,this.imgIconFile,this.temp.memo,respon => {
                  // console.log("respon",respon);

                  // this.$dialogMethod.showMessage("添加成功!")
                  this.$message({message: "添加成功",type: 'success'});
                  //刷新页面
                  this.getList()
                  this.dialogVisible=false
                },respon => {
                  // console.log("respon",respon);
                  this.$message({message: respon,type: 'error'});
                })
            }

          } else {
            return false;
          }
        });
      },
      
      //添加子菜单
      addMenuChild (nowMenu) {
        this.dialogStatus='addSon';
        if(nowMenu.hasSonMenu==0) {
          this.$message({message: '请先把 '+nowMenu.rightname+' 修改成有子菜单',type: 'warning'});
          return
        }
        this.dialogVisible=true;
        this.nowMenu=nowMenu
        this.textMap.addSon='新增子级菜单（'+nowMenu.rightname+'）'
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
        this.temp={};

      },
      //修改
      editMenu (v) {
        this.dialogStatus='edit';
        this.dialogVisible=true;
        this.nowMenu=v
        this.radioValue=v.hasSonMenu.toFixed(0)
        this.imgIconFile=v.iconFile
        if(v.iconFile) {
          this.imageUrl="./static/image/科技蓝/menu/"+v.iconFile+".png"
        } else {
          this.imageUrl=""
        }

        this.temp=Object.assign({},v);
        //  this.textMap.edit = '修改web菜单（'+v.rightname+'）'
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });


      },
      //确定修改
      edit_fn () {
        this.$refs['temp'].validate(valid => {
          if(valid) {
            //修改接口
            this.$api.menuApi.saveMenu(this.nowMenu.id,this.temp.rightname,
              this.nowMenu.righttype,this.nowMenu.serialno,this.temp.webpage,this.nowMenu.parentid,"1","1",this.radioValue,this.imgIconFile,this.temp.memo,respon => {
                // this.$dialogMethod.showMessage("修改成功!")
                this.$message({message: "修改成功",type: 'success'});
                //刷新页面
                this.getList()
                this.dialogVisible=false;
                this.$store.menuStore.commit("getMenuList")
              },respon => {
                err(respon)
                this.$message({message: respon,type: 'error'});
              })
          } else {
            return false;
          }
        });

      },
      //删除
      deleteMenu (nowMenu) {
         this.$confirm(`是否删除 ${nowMenu.rightname}`,'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
                var id=nowMenu.id //当前选中web菜单的id
              //删除接口
              this.$api.menuApi.deleteMenuById(id,respon => {
                // this.$dialogMethod.showMessage(respon)
                this.$message({message: respon,type: 'success'});
                // this.nowMenu = undefined
                this.getList()
                this.$store.menuStore.commit("getMenuList")
              },respon => {
                err(respon)
                this.$message({message: respon,type: 'error'});
              })
        }).catch(() => {
          // ...
        });

      },

      //获取列表数据
      getList () {
        menuApi.getAllRight(this.$store.userStore.state.nowUserInfo.userId,res => {
          this.tableData=res.menuRight
          console.log("tableData",this.tableData);
          this.tableDataRight[0].next = this.tableData
          this.tableDataCopy=res.menuRight
          if(this.drawer){
            this.defaultExpanded = [this.rightidsss]
                this.defaultDevice = this.rightidsss
              this.$nextTick(()=>{
              //默认选中
              this.$refs['trees'].setCurrentKey(this.defaultDevice);
            })
          }
        })
        userManagerStore.commit('getAllRightCopy',this.$store.userStore.state.nowUserInfo.userId)
        // menuApi.getMenu("menuright", true, respon => {
        // 			this.tableData = respon
        // })




      },


    }
  };
</script>

<style lang="scss" scoped>
/deep/.el-table__row--level-0 .el-table td, .el-table th {
    padding: 6px 0px !important;
}
/deep/.el-table__row--level-1 .el-table td {
    padding: 10px 0px !important;
}
/deep/.el-table__expand-icon {
   margin-right: 0px;
}
/deep/.is-left .cell {
  display: flex;
  align-items: center;
}
.drawer-con {
   padding: 12px 20px 20px 20px;
}
.dra-btns {
   width: 88px;
   margin: 0px 12px;
   margin-top: 240px;
   .left-add,.del{
     width: 88px;
     height: 32px;
     background-color: #368ED9;
     color: #fff;
     display: flex;
     align-items: center;
     justify-content: center;
     border-radius: 2px;
   }
   .del {
       background-color: #ED6547;
       margin-top: 40px;
   }
}

.dratree {
  padding: 20px 12px 12px 12px;
  box-sizing: border-box;
  border-right:1px solid #ccc;
 
}
.dratree2 {
  padding: 20px 12px 12px 12px;
  box-sizing: border-box;
    border-left:1px solid #ccc;
}
.name-menu  {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
 .webMenuConfig {
      .con{
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        background-color: #fff;
          padding: 12px 20px 20px 20px;
       
	    }
        .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 10px;
      }
      .public-flex {
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 20px !important;
            height: 20px !important;
          }
      }
      .img-div {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .content-img {
        width: 32px;
        height: 32px;
        background-color: #000;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 2px;
      }
      .el-table__row--level-1 .content-img {
         background-color:transparent
      }
      .el-table__row--level-2 .content-img {
         background-color:transparent
      }

    
     
  }
</style>